import { all, fork } from 'typed-redux-saga';

import { SAGAS } from '@/shoppingCart/CartOverview/sagas';

export function* rootCartOverview() {
  yield* all(SAGAS.map(fork));
}
